"use strict";

exports.__esModule = true;
exports.DEFAULT_INTERVAL = exports.DEFAULT_ITEM_WIDTH = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var FullFlat_1 = tslib_1.__importDefault(require("./Modes/FullFlat"));

var FullRotation_1 = tslib_1.__importDefault(require("./Modes/FullRotation"));

var SingleRotation_1 = tslib_1.__importDefault(require("./Modes/SingleRotation"));

exports.DEFAULT_ITEM_WIDTH = 200;
exports.DEFAULT_INTERVAL = 2000;

var Banners = function (_a) {
  var _b = _a.data,
      data = _b === void 0 ? {} : _b,
      renderEmpty = _a.renderEmpty;
  var items = data.items || [];
  var width = !data.width || data.width < 1 ? exports.DEFAULT_ITEM_WIDTH : data.width;
  var interval = !data.interval || data.interval < 1000 ? exports.DEFAULT_INTERVAL : data.interval;
  var invalid = !data.mode || !items.length;

  if (invalid && renderEmpty) {
    return react_1["default"].createElement(react_1["default"].Fragment, null, renderEmpty(data.type));
  }

  if (invalid) {
    return null;
  }

  switch (data.mode) {
    case 'full-flat':
      return react_1["default"].createElement(FullFlat_1["default"], {
        items: items,
        width: width
      });

    case 'full-rotation':
      return react_1["default"].createElement(FullRotation_1["default"], {
        items: items,
        width: width
      });

    case 'single-rotation':
      return react_1["default"].createElement(SingleRotation_1["default"], {
        items: items,
        width: width,
        interval: interval
      });

    case 'single-random-rotation':
      return react_1["default"].createElement(SingleRotation_1["default"], {
        items: items,
        width: width,
        interval: interval,
        randomOrder: true
      });

    default:
      return null;
  }
};

exports["default"] = Banners;